//  export const environment = {
//     production: true,
//    baseUrl: "./serverI",
//     baseDoc:"https://extranet.seguroscaroni.com/DokumentS"
//   };
 

export const environment = {
  production: false,
  endpoint: "",
  urlApi: "",
  baseUrl: "https://extranet.seguroscaroni.com/sc-intermediarios/serverI",
  // baseUrl: "http://192.90.130.252/serverII", -> Prueba con Prod.
  baseDoc:"https://extranet.seguroscaroni.com/DokumentS",
  //API_URL: "http://localhost:3002"
  API_URL : "https://extranet.seguroscaroni.com/emitter",
  apiBank: "https://sypago.net:8086/api/v1/banks",
  baseUrl2: "https://extranet.seguroscaroni.com/security"

};
